import createPersistedReducer from 'lib/createPersistedReducer.js';

import { marked } from 'marked';
import parseAllDocumenation from 'screens/help/lib/parseAllDocumenation.js';

const renderer = {
  link(href, title, text) {
    if (String(text).includes('www.youtube')) {
      return ``;
    }
    return `
      <a href='${href}'>${text}</a>
    `;
  },
};

marked.use({ renderer });

const initialState = () => ({
  search: '',
  docs: [],
});

const persistConfig = {
  key: 'helpScreenReducer',
  blacklist: [],
};

let helpScreen = createPersistedReducer(
  initialState(),
  {
    GET_DOCUMENTATION_SUCCESS: (state, action) => ({
      ...state,
      docs: parseAllDocumenation((((action.data || {}).documentation || {}).data || {}).allDocumentations || []),
    }),

    helpSetSearch: (state, data) => ({
      ...state,
      search: data,
    }),
  },
  persistConfig
);

export default helpScreen;
